import type { PremiumAchPullStatus } from '../types'

import { CaretDownOutlined } from '@ant-design/icons'
import { Dropdown, Spin, Tag } from 'antd'

import { PremiumAchPullStatusMapper } from '../types'

interface Props {
  status: PremiumAchPullStatus
  onClick: (status: PremiumAchPullStatus) => void
  loading?: boolean
  className?: string
}

export const PullStatusSelector = (props: Props): JSX.Element => {
  const status = PremiumAchPullStatusMapper[props.status]
  const statuses = status.transition

  const menu = {
    items: statuses.map(s => ({
      onClick: () => {
        props.onClick(s)
      },
      key: s,
      label: (
        <Tag
          color={PremiumAchPullStatusMapper[s].color}
          title={PremiumAchPullStatusMapper[s].name}
          className='font-lato size-xs'
        >
          {PremiumAchPullStatusMapper[s].name}
        </Tag>
      )
    }))
  }

  return (
    <Dropdown menu={menu} trigger={['hover']} className={props.className} disabled={props.loading}>
      <div>
        <Tag
          color={status.color}
          title={status.name}
          className={`font-lato size-xs ml-auto ${statuses.length > 0 && props.loading !== true ? 'cursor-pointer' : ''}`}
        >
          {status.name}
          {statuses.length > 0 &&
            (props.loading === true ? (
              <Spin size='small' className='ml-1' />
            ) : (
              <CaretDownOutlined className='ml-1' />
            ))}
        </Tag>
      </div>
    </Dropdown>
  )
}
